const DisableUserModal = ({ isOpen, user, onClose, onConfirm, isLoading }) => {
  if (!isOpen || !user) return null;

  // Resource persons carry a `status` field (ACTIVE / DEACTIVATED).
  const isActive = user.status ? user.status === "ACTIVE" : Boolean(user.isActive);
  const displayName = user.name || user.email || "this user";

  return (
    <div
      className="modal"
      style={{
        display: "flex",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1050,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "24px",
          maxHeight: "90vh",
          overflowY: "auto",
          width: "min(90vw, 480px)",
        }}
      >
        {isActive ? <h5>Disable User</h5> : <h5>Enable User</h5>}

        <div className="">
          <span className="disableText">
            Are you sure you want to {isActive ? "disable" : "enable"}
            <span className={isActive ? "text-danger" : "text-success"}> {displayName}</span>
          </span>
        </div>
        <div className="mb-3">
          <label className="d-flex align-items-center gap-2">
            <span>Toggle Status:</span>
            <label
              className="switch"
              style={{
                position: "relative",
                display: "inline-block",
                width: "50px",
                height: "26px",
                cursor: isLoading ? "not-allowed" : "pointer",
              }}
            >
              <input
                type="checkbox"
                checked={isActive}
                disabled={isLoading}
                onChange={onConfirm}
                style={{ opacity: 0, width: 0, height: 0 }}
              />
              <span
                className="slider round"
                style={{
                  position: "absolute",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: isActive ? "#28a745" : "#ccc",
                  transition: ".3s",
                  borderRadius: "26px",
                }}
              >
                <span
                  style={{
                    position: "absolute",
                    content: "",
                    height: "20px",
                    width: "20px",
                    left: isActive ? "26px" : "4px",
                    bottom: "3px",
                    backgroundColor: "white",
                    transition: ".3s",
                    borderRadius: "50%",
                  }}
                />
              </span>
            </label>
          </label>
        </div>
        <div className="modal-buttons">
          <button
            type="submit"
            className={`btn btn-theme2 ${isActive ? "btn-danger" : "btn-success"}`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="spinner-border text-light btnspinner" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : isActive ? (
              "Disable"
            ) : (
              "Enable"
            )}
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisableUserModal;